import { ReactNode } from 'react';

/** Rotate-only border spinner (old-WebView cheap). */
export function Spinner({ size = 16, label }: { size?: number; label?: ReactNode }) {
  return (
    <span className="row" style={{ gap: 8, display: 'inline-flex' }}>
      <span className="spinner" style={{ width: size, height: size }} aria-hidden="true" />
      {label != null && <span className="muted small">{label}</span>}
    </span>
  );
}
